import "./v2-question-surface.css";

export function GhostButton({ children, ...props }) {
  return (
    <button className="tgc-v2-button tgc-v2-button--ghost" type="button" {...props}>
      {children}
    </button>
  );
}

export function DimensionalGoldButton({ children, ...props }) {
  return (
    <button className="tgc-v2-button tgc-v2-button--gold" type="button" {...props}>
      {children}
    </button>
  );
}

export default function ActionRow({
  variant = "two-button",
  onBack,
  onSkip,
  onNext,
  nextDisabled,
  nextLabel = "Next",
}) {
  if (variant === "back-only") {
    return (
      <div className="tgc-v2-action-row tgc-v2-action-row--back-only">
        <GhostButton onClick={onBack}>Back</GhostButton>
      </div>
    );
  }

  if (variant === "three-button") {
    return (
      <div className="tgc-v2-action-row tgc-v2-action-row--three-button">
        <GhostButton className="tgc-v2-button tgc-v2-button--ghost tgc-v2-button--three" onClick={onBack}>
          Back
        </GhostButton>
        <GhostButton className="tgc-v2-button tgc-v2-button--ghost tgc-v2-button--skip" onClick={onSkip}>
          Skip
        </GhostButton>
        <DimensionalGoldButton
          className="tgc-v2-button tgc-v2-button--gold tgc-v2-button--three"
          onClick={onNext}
          disabled={nextDisabled}
          data-disabled={nextDisabled ? "true" : "false"}
        >
          {nextLabel}
        </DimensionalGoldButton>
      </div>
    );
  }

  if (variant === "done-only") {
    return (
      <div className="tgc-v2-action-row tgc-v2-action-row--done-only">
        <DimensionalGoldButton
          onClick={onNext}
          disabled={nextDisabled}
          data-disabled={nextDisabled ? "true" : "false"}
        >
          {nextLabel}
        </DimensionalGoldButton>
      </div>
    );
  }

  return (
    <div className="tgc-v2-action-row">
      <DimensionalGoldButton
        onClick={onNext}
        disabled={nextDisabled}
        data-disabled={nextDisabled ? "true" : "false"}
      >
        {nextLabel}
      </DimensionalGoldButton>
      <GhostButton onClick={onBack}>Back</GhostButton>
    </div>
  );
}
